import {observer} from 'mobx-react';
import {Panel, EmployeeNameWithAvatar, ActionLink} from 'shared/components';
import {Table} from 'main/components';
import {FormattedMessage} from 'react-intl';
import {useIsBelowBreakpoint, useModal} from 'shared/hooks';
import {t} from 'shared/core';
import ActionNoteModal from './ActionNoteModal';

const ActionNote = observer(({model: action, uiState}) => {
  const {employee, notes} = action;

  if (!notes) return null;

  return (
    <ActionLink onClick={() => uiState.openActionNoteModal({author: employee, message: notes})}>
      <FormattedMessage
        id='employees.profile.time_off.NOTES'
        values={{
          number: 1
        }}
      />
    </ActionLink>
  );
});

const Action = observer(({model}) => {
  const {action, isMultiStage, stage} = model;

  const isStatus = ['approved', 'rejected'].includes(action);

  if (!isStatus) {
    return (
      <>{action}</>
    );
  }

  const stageAsNumber = stage === 'first' ? 1 : 2;

  return (
    <>
      <FormattedMessage id={`models.time_off_request.status.${action}`} />
      {isMultiStage &&
        <p className='waterloo'>
          (<FormattedMessage id='time_off.requests.APPROVAL_STAGE' values={{currentStage: stageAsNumber}} />)
        </p>
      }
    </>
  );
});

const COLUMNS = [
  {
    header: 'employees.profile.time_off.request.history.Name',
    width: 3,
    render: ({employee}) => employee ? <EmployeeNameWithAvatar employee={employee} /> : ''
  },
  {
    header: 'employees.profile.time_off.request.history.Action',
    width: 3,
    component: Action
  },
  {
    header: 'employees.profile.time_off.request.history.Date',
    attribute: 'date',
    width: 2,
  },
  {
    header: 'employees.profile.time_off.request.history.Delegated By',
    width: 3,
    render: ({delegatedBy}) => delegatedBy ? <EmployeeNameWithAvatar employee={delegatedBy} /> : ''
  },
  {
    header: 'employees.profile.time_off.request.history.Note',
    width: 1,
    component: ActionNote
  },
];

const RequestHistory = observer(({uiState}) => {
  const {historyItems} = uiState;

  const actionNoteModalOpen = useModal(uiState, 'ActionNoteModal', 'selectedNote');
  const horizontalScroll = useIsBelowBreakpoint('xlarge');

  return (
    <Panel>
      <Panel.Header title={t('employees.profile.time_off.request.Approval History')} />
      <Table
        uiState={uiState}
        horizontalScroll={horizontalScroll}
        showLinks={false}
        columns={COLUMNS}
        models={historyItems}
      />
      <ActionNoteModal uiState={uiState} modalOpen={actionNoteModalOpen} />
    </Panel>
  );
});

export default RequestHistory;
